import { Injectable } from "@angular/core";
import{ Http, Headers } from "@angular/http";
import { map, timeout} from 'rxjs/operators';
import { GLOBAL } from './global';
import { HttpClientModule, HttpHeaders, HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class DocumentoService {
    public url;

    constructor(private _http: HttpClient){
        this.url = GLOBAL.url;
    }

    getDocumento(){
        console.log('getDocument');
       return this._http.get("assets/json/pasos.json").pipe(map(response => response));  

              
       

    }
    getUploaders(){
        return this._http.get("assets/json/documentos.json")
        .pipe(map((response: any) => response.json()));            }
    uploadFile(file){
        let headers = new HttpHeaders({
            'Content-type': 'application/json',
            'Authorization': sessionStorage.getItem("token-domCloud")
        });
        return this._http.post(this.url+'save/archivos', file, {headers: headers})
        .pipe(map(response => response));     }

    uploadF(files, user){
        let headers = new HttpHeaders({
            'Content-Type': 'application/json',
        });

        var params =  {
            files: files,
            user : user
        }

        return this._http.post(this.url+'upload/ftp', params, {headers:headers})
        
    }

    uploadFilesDBX(files, formType = ''): Observable<any>{

        const formData  = new FormData();
        formData.append('formType', formType)

        files.map((file) => {
            if (!(file == null || file== undefined)) {
                let doExt = file.doc.name.split(".")
                doExt = file.name +'-'+ new Date().getTime() + '.' + doExt[ doExt.length -1 ]
                let fil: File
                fil = file.doc
                formData.append('uploads[]', fil , doExt);
            }
        })
            return this._http.post(this.url + 'upload/dbx', formData);
    }


    uploadBNUPDBX(files, formType = ''){
         console.log('documentoTs');
        const formData  = new FormData();
        formData.append('formType', formType)

        files.map((file) => {
            console.log(file ,'param File');
            if (file !== null || file !== undefined ) {
                let doExt = file.doc.name.split(".")
                doExt = file.name +'-'+ new Date().getTime() + '.' + doExt[ doExt.length -1 ]
                let fil: File
                fil = file.doc
                formData.append('uploads[]', fil , doExt);
            }
            console.log('81',file ,formData);
        })
        console.log('object');

            return this._http.post(this.url + 'upload/bnup/dbx', formData)
            // .pipe(map((response: any) => response.json()));
            console.log('object');

    }





    uploadInspeccionDBX(files, formType = ''){
        console.log('documentoTs');
       const formData  = new FormData();
       formData.append('formType', formType)

       files.map((file) => {
           console.log(file ,'param File');
           if (file !== null || file !== undefined ) {
               let doExt = file.doc.name.split(".")
               doExt = file.name +'-'+ new Date().getTime() + '.' + doExt[ doExt.length -1 ]
               let fil: File
               fil = file.doc
               formData.append('uploads[]', fil , doExt);
           }
           console.log('81',file ,formData);
       })
       console.log('object');

           return this._http.post(this.url + 'upload/inspeccion/dbx', formData)
           // .pipe(map((response: any) => response.json()));
           console.log('object');

   }





    uploadFiles(files, formType = ''){

        const formData  = new FormData();
        formData.append('formType', formType)

        files.map((file) => {
            if (!(file == null || file== undefined)) {
                let doExt = file.doc.name.split(".")
                doExt = file.name +'-'+ new Date().getTime() + '.' + doExt[ doExt.length -1 ]
                let fil: File
                fil = file.doc
                formData.append('uploads[]', fil , doExt);
            }
        })
            return this._http.post(this.url + 'upload/webservice', formData)
            .pipe(map((response: any) => response.json()));
    }

}
